import { ChangeDetectionStrategy, Component, effect, input, model, OnDestroy, OnInit, output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EMAIL_REGEX } from '../../core';
import { BaseComponent, ReplacePipe } from '../../shared';


/**
 * Component for patient Contact Info.
 */
@Component({
	selector: 'tsp-contact-info',
	imports: [
		FormsModule,
		ReplacePipe,
		ReactiveFormsModule
	],
	templateUrl: './contact-info.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ContactInfoComponent extends BaseComponent implements OnInit, OnDestroy {

	emailAddress = model<string | null>(null);
	secondEmailAddress = model<string | null>(null);
	isReadonly = input<boolean>(false);
	isValid = output<boolean>();

	readonly EMAIL_MAXLENGTH = 128;

	form = new FormGroup({
		'email': new FormControl<string | null>(null, [
			Validators.required,
			Validators.pattern(EMAIL_REGEX),
			Validators.maxLength(this.EMAIL_MAXLENGTH)
		]),
		'secondEmail': new FormControl<string | null>(null, [
			Validators.pattern(EMAIL_REGEX),
			Validators.maxLength(this.EMAIL_MAXLENGTH)
		])
	})

	private _changeSub$?: Subscription;

	ngOnInit(): void {
		this._changeSub$ = this.form.valueChanges.subscribe(val => {
			this.isValid.emit(this.form.valid);
			this.emailAddress.set(val.email ?? null);
			this.secondEmailAddress.set(val.secondEmail ?? null);
		});
	}

	private readonly init = effect(() => this.form.setValue({
		email: this.emailAddress(),
		secondEmail: this.secondEmailAddress()
	}));

	
	ngOnDestroy(): void {
		this._changeSub$?.unsubscribe();
	}

}
